import { hsaSiteConfig } from '../config/hsa/site.config';

export const environment = {
  production: false,
  x_api_key: 'w3NQFPoUOSqE29k6PPD4XDnOOPd9uf5X',
  apiUrl: 'https://api-healthsuite-dev.kozaca.com.ar/api',
  apiUrl_photo: 'https://api-healthsuite-dev.kozaca.com.ar',
  portalUrl: 'https://portal-paciente-healthsuite-dev.kozaca.com.ar',
  auth: {
    clientId: '019e26ce-6567-7220-8a87-b2ac832718ce',
    clientSecret: '0uarl1WvkDd1pbRN0FOCJBIGul6qG7HCA2aFnv2r',
  },
  siteConfig: hsaSiteConfig,
};
